export default function DropdownIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10">
      <polygon points="0,2 10,2 5,9" fill="currentColor" />
    </svg>
  );
}
